module.exports = __webpack_public_path__ + "static/cornershopapp-2d42d70809ab799c161af5689fdda8f5.png";